import * as _ from 'lodash';
import numeral from 'numeral';
import React from 'react';

import {
  PROPERTY_TYPE_DECIMAL,
  PROPERTY_TYPE_TOGGLE,
  PROPERTY_TYPE_UPLOAD,
} from '@marketreach/components/section/PropertyItem';
import { getFileUploadImage } from '@marketreach/utils/files';

import { sortByOrder } from '../common';

export const sortTable = (a, b) => {
  if (typeof a === 'number') {
    return a - b;
  }

  if (typeof a === 'string') {
    return (a || '').localeCompare(b || '');
  }

  if (a === undefined) {
    return -1;
  }

  return JSON.stringify(a).localeCompare(JSON.stringify(b));
};

export const getSectionColumns = (sections) => {
  if (!sections) {
    return [];
  }

  let properties = [];
  sections
    .slice()
    .sort(sortByOrder)
    .forEach((section) => {
      if (section.properties) {
        properties = properties.concat(
          section.properties.slice().sort(sortByOrder)
        );
      }
    });

  if (!properties) {
    return [];
  }

  const columns = [];
  properties.forEach((property) => {
    if (property?.settings) {
      const baseColumnSettings = {
        title: property.settings.label || '',
        dataIndex: property.settings.key || '',
        ellipsis: true,
        width: 175,
        propertyType: property.propertyType.title,
        sorter: (a, b) =>
          sortTable(a[property.settings.key], b[property.settings.key]),
      };

      if (property.propertyType.title === PROPERTY_TYPE_UPLOAD) {
        columns.push({
          ...baseColumnSettings,
          width: 100,
          render: (text, row) => {
            const files = [];

            if (_.isArray(row[property.settings.key])) {
              for (const item of row[property.settings.key]) {
                files.push({
                  src: getFileUploadImage(item),
                  alt: item.name,
                });
              }
            } else {
              files.push({ src: row[property.settings.key] });
            }
            return files
              .filter((item) => item?.src?.length > 0)
              .map((item) => (
                <img
                  width="30"
                  height="30"
                  src={item.src}
                  alt={item.alt || 'product thumb'}
                />
              ));
          },
        });
      } else if (property.propertyType.title === PROPERTY_TYPE_TOGGLE) {
        columns.push({
          ...baseColumnSettings,
          render: (text, row) => (
            <div>{row[property.settings.key]?.toString()}</div>
          ),
        });
      } else if (property.propertyType.title === PROPERTY_TYPE_DECIMAL) {
        columns.push({
          ...baseColumnSettings,
          render: (text, row) => (
            <div>
              {numeral(row[property.settings.key]).format(
                property.settings?.displayMask ?? '0.00'
              )}
            </div>
          ),
        });
      } else {
        columns.push({
          ...baseColumnSettings,
        });
      }
    }
  });

  return columns;
};

export const getNestedProducts = (products, productIds) => {
  if (!products || products === []) {
    return [];
  }

  const nestedProducts = [];
  productIds.forEach((productId) => {
    const children = products.filter(
      (product) => productId === product.product_id
    );
    if (children && children[0]) {
      nestedProducts.push(children[0]);
    }
  });

  return nestedProducts;
};
